import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { catchError } from 'rxjs/operators';

import { ArquivoService } from '../../../arquivo/arquivo.service';
import { StringUtil } from '../../../utils/string-util';


enum TipoDeMedia {
  VIDEO = 'VIDEO', 
  IMAGEM = 'IMAGEM',
  ARQUIVO = 'ARQUIVO'
};

@Component({
  selector: 'app-media-viewer',
  templateUrl: './media-viewer.component.html',
  styleUrls: ['./media-viewer.component.css']
})
export class MediaViewerComponent implements OnInit, OnDestroy {

  private fileURL: string = null;

  @Input() urlArquivo: string = null;

  @ViewChild('imagem') imagem: ElementRef;
  @ViewChild('video') video: ElementRef;
  @ViewChild('videoSource') videoSource: ElementRef;
  @ViewChild('linkArquivo') linkArquivo: ElementRef;

  msgDeErro = null;
  exibirCarregando = false;
  tipoDeMedia: TipoDeMedia = null;

  constructor(
    private arquivoService: ArquivoService
  ) {}

  ngOnInit(): void {
    this.carregarArquivo(this.urlArquivo);
  }

  ngOnDestroy(): void {
    try {
      URL.revokeObjectURL(this.fileURL);      
    }
    catch(e) {}
  }

  identificarTipoDeMedia(): TipoDeMedia {
    const extensao = StringUtil.getExtensaoDoArquivo(this.urlArquivo).toLowerCase();
    switch ( extensao ) {
      case 'png':
      case 'jpeg':
      case 'jpg':
        return TipoDeMedia.IMAGEM;

      case 'mp4':
      case 'mpeg':
      case 'mov':
      case 'avi':
        return TipoDeMedia.VIDEO;

      default:
        return TipoDeMedia.ARQUIVO;
    }
  }


  carregarArquivo(urlArquivo: string): void {
    if ( !urlArquivo ) {
      return;
    }

    this.exibirCarregando = true;

    this.arquivoService
        .getArquivo(urlArquivo)
        .pipe(
          catchError ( err => {
            this.exibirCarregando = false;
            this.msgDeErro = 'Ocorreu um erro na operação.';

            return err;
           })
        )
        .subscribe((response: any) => {
          this.exibirCarregando = false;
          
          const file = new Blob([response], { type: response.type });
          this.fileURL = URL.createObjectURL(file);

          this.tipoDeMedia = this.identificarTipoDeMedia();

          setTimeout(() => {
            this.exibirMedia(this.tipoDeMedia, this.fileURL, response.type);
          }, 500);

        });
  }

  private exibirMedia(tipoDeMedia: TipoDeMedia, fileURL: string, tipo: string): void {
    if ( this.tipoDeMedia === TipoDeMedia.IMAGEM ) {
      this.exibirImagem(fileURL);
    }
    else if ( this.tipoDeMedia === TipoDeMedia.VIDEO ) {
      this.exibirVideo(fileURL, tipo);
    }
    else {
      this.exibirLink(fileURL, tipo);
    }
  }

  private exibirImagem(fileURL: string): void {
    this.imagem.nativeElement.src = fileURL;
    this.imagem.nativeElement.onload = function() {
      URL.revokeObjectURL(fileURL);
    };    
  }

  private exibirVideo(fileURL: string, type: string): void {
    this.videoSource.nativeElement.type = type;
    this.videoSource.nativeElement.src = fileURL;
    this.video.nativeElement.load();
    this.video.nativeElement.onloadeddata = function() {
        // this.video.nativeElement.play();
      URL.revokeObjectURL(fileURL);
    }
  }

  private exibirLink(fileURL: string, type: string): void {
    this.linkArquivo.nativeElement.href = fileURL;
  }

}
